import moment from 'moment';
import Utility from '../../../../../util/utilityfunctions';
import {timeFormat} from '../../../../../util/uiconstants';

export const getDateAndHourToExport = (userDateFormat, userTimezone) => {
	const userDateAndHourFormat = `${userDateFormat} ${timeFormat}`;
	const exportDate = moment().utc();
	return `${exportDate.format(userDateAndHourFormat)} UTC`;
};
